import { widgetIdsNode } from './widgetIdsNode'
import { getInvalidationHandler } from './invalidationHandler'
import type { IocContainer } from '@wix/thunderbolt-ioc'
import { CompNodeProviderSymbol, OnInvalidationSymbol } from '@wix/thunderbolt-catharsis-ioc'

export const addInvalidation = (container: IocContainer): Set<string> => {
	const set = new Set<string>()

	const onInvalidation = getInvalidationHandler(set)
	container.bind(OnInvalidationSymbol).toConstantValue(onInvalidation)

	container.bind(CompNodeProviderSymbol).toConstantValue({
		getCompNodes: () => ({ widgets: widgetIdsNode }),
		getUsedDataMaps: () => ['document_data'],
	})

	return set
}
